enum FormState {
  HOVER = 'Hover',
  DISABLED = 'Disabled',
  LOADING = 'Loading',
  READY = 'Ready',
  SAVING = 'Saving',
  ERROR = 'Error',
}

export default FormState;
